export const userLogged = (authID) => {
  return (
    typeof authID !== "undefined" &&
    authID !== null &&
    (Boolean(authID.i) || Boolean(authID.u))
  );
};
